/**
 * Overides the navigation link for scheduling an appointment.
 * If another 'Schedule an Appointment' link is present on a
 * page, the page content link attributes will be copied to the
 * navigation link to prevent the nav link from simply reloading the page
 */

const pageAppointmentLink = document.querySelector('#js-appointment.actionBar a.actionBar__item');

if (pageAppointmentLink) {
    const navAppointmentLink = document.querySelector('#mainNav a.bareLink.-js-appointment');
    if (navAppointmentLink) {
        navAppointmentLink.setAttribute('href',  pageAppointmentLink.getAttribute('href'));
        navAppointmentLink.setAttribute('data-lightbox-height', pageAppointmentLink.getAttribute('data-lightbox-height'));
        navAppointmentLink.setAttribute('data-lightbox-loading-message', pageAppointmentLink.getAttribute('data-lightbox-loading-message'));
        navAppointmentLink.setAttribute('data-lightbox-width', pageAppointmentLink.getAttribute('data-lightbox-width'));
        navAppointmentLink.setAttribute('target', pageAppointmentLink.getAttribute('target'));
        navAppointmentLink.setAttribute('onclick', pageAppointmentLink.getAttribute('onclick'));
    }
}